import { RealtimeClient } from '@supabase/realtime-js';
import { env } from '@/env';
import { authClient } from './auth';

/**
 * The websocket the browser opens DIRECTLY to Supabase, bypassing our API entirely.
 *
 * Because our server is not in this path, it cannot police what gets delivered —
 * Postgres does, by evaluating the RLS policy from migration 0018 once per subscriber
 * per event. That is why those policies are written as carefully as they are.
 */
export const realtimeClient = new RealtimeClient(`${env.supabaseUrl}/realtime/v1`, {
  params: { apikey: env.supabaseAnonKey, eventsPerSecond: 10 },
});

/**
 * MANDATORY, and easy to miss because nothing fails loudly without it.
 *
 * Realtime caches the access token per connection. A tab left open past the token's
 * hour-long TTL keeps a socket whose JWT has expired, and postgres_changes silently
 * stops delivering — the board just quietly goes stale. One line; the difference
 * between "realtime works" and "realtime works for an hour".
 */
authClient.onAuthStateChange((_event, session) => {
  if (session?.access_token) realtimeClient.setAuth(session.access_token);
});

export async function primeRealtimeAuth(): Promise<void> {
  const { data } = await authClient.getSession();
  if (data.session?.access_token) realtimeClient.setAuth(data.session.access_token);
}
